import { List, Skeleton } from 'antd';
import { NftCardSkeleton } from 'components/Shared/NftCard/Skeleton';
import * as Styled from './styles';
import { itemsMockData } from 'constants/mockData/items';

interface IListItem {
  name: string;
  value: string;
}

const data: IListItem[] = [
  {
    name: 'Highest Sale',
    value: '43.2 AED'
  },
  {
    name: 'Market Cap',
    value: '99.8 AED'
  },
  {
    name: 'Total Volume',
    value: '22.81 AED'
  },
  {
    name: 'Owners',
    value: '374'
  },
  {
    name: 'Items',
    value: '33.8 K'
  }
];

type CollectionViewSkeletonProps = {
  isMobile?: boolean;
};

export const CollectionViewSkeleton = (props: CollectionViewSkeletonProps) => {
  return (
    <Styled.SkeletonWrapper>
      <div className="container_v3 container-fluid_v3">
        <div className="row_v3">
          <div className="col_v3-xs-12 col_v3-sm-12 col_v3-md-12 col_v3-lg-12">
            <Styled.CardContent>
              <Skeleton.Button
                active
                className="full-width"
                style={{
                  paddingBottom: props.isMobile ? '61.94%' : '32.94%',
                  borderRadius: '16px'
                }}
              />
              <Styled.ArtistAvatar>
                <Skeleton.Avatar
                  active
                  style={{ height: '80px', width: '80px' }}
                />
              </Styled.ArtistAvatar>
            </Styled.CardContent>
          </div>
        </div>
        <div className="row_v3">
          <div className="col_v3-xs-12 col_v3-sm-12 col_v3-md-8 col_v3-lg-8">
            <Skeleton active style={{ marginTop: '40px' }} />
          </div>
          <div className="col_v3-xs-12 col_v3-sm-12 col_v3-md-4 col_v3-lg-4">
            <Styled.ListBlockWrapper>
              <Styled.ListBlock
                size="small"
                dataSource={data}
                renderItem={i => {
                  const item = i as IListItem;
                  return (
                    <List.Item key={item.name}>
                      <Skeleton
                        active
                        style={{
                          width: '100%',
                          display: 'flex',
                          justifyContent: 'space-between'
                        }}
                        title={{
                          style: {
                            width: '50%',
                            height: '10px',
                            margin: '4px 0 8px 5px'
                          }
                        }}
                        paragraph={false}
                      />
                    </List.Item>
                  );
                }}
              />
            </Styled.ListBlockWrapper>
          </div>
        </div>
        <div className="row_v3">
          <div className="col_v3-xs-12 col_v3-sm-12 col_v3-md-12 col_v3-lg-12">
            <div
              style={{
                display: 'grid',
                gridTemplateRows: '1fr auto',
                gridTemplateColumns: props.isMobile
                  ? 'repeat(2, calc((100% - 20px)/2))'
                  : 'repeat(4, calc((100% - 20px)/4))',
                gap: '12px'
              }}
            >
              {itemsMockData.map(item => (
                <NftCardSkeleton key={item.id} size="medium" flexible />
              ))}
            </div>
          </div>
        </div>
      </div>
    </Styled.SkeletonWrapper>
  );
};
